import { CONTACT } from '@/constants/contact';

/**
 * Resolves the WhatsApp support number used by the CPM payout ("Solicitar
 * saque") buttons. Prefers the build-time `VITE_SUPPORT_WHATSAPP` value, but
 * falls back to the canonical support number so the button always works even
 * when the env var is unset in a given deploy.
 */
export function resolveSupportWhatsapp(envPhone?: string | null): string {
  const trimmed = envPhone?.trim();
  return trimmed ? trimmed : CONTACT.PHONE_NUMBER;
}
